import { useParams } from "react-router-dom";
import { PropertyContextProvider } from "@/contexts/PropertyContext";
import EditProperty from "@/pages/owner/EditProperty";

/**
 * Wraps EditProperty with PropertyContextProvider so permission checks (e.g. canEditPropertyConfig) work.
 * Used by route /properties/:propertyId/edit (PropertyAccessGuard wraps this).
 */
export default function EditPropertyRoute() {
  const { propertyId } = useParams<{ propertyId: string }>();
  return (
    <PropertyContextProvider propertyId={propertyId}>
      <EditProperty />
    </PropertyContextProvider>
  );
}
